import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { SendReportV1CaseDetails } from './v1';
import { SectionLayout } from './v1/section-layout';

interface SendReportVersionRouterProps {}

const SendReportVersionRouter: React.FC<SendReportVersionRouterProps> = () => {
  return (
    <Routes>
      <Route path="" element={<SectionLayout />} />
      <Route path="v1/*" element={<SendReportV1CaseDetails />} />
    </Routes>
  );
};

export default SendReportVersionRouter;
